<template>
  <div class='newplace'>
    <img src="/static/images/activty/freeaway/appfreeaway_01.jpg">
    <img src="/static/images/activty/freeaway/appfreeaway_02.jpg">
    <img src="/static/images/activty/freeaway/appfreeaway_03.jpg">
    <img src="/static/images/activty/freeaway/appfreeaway_04.jpg">
    <img src="/static/images/activty/freeaway/appfreeaway_05.jpg">
    <img src="/static/images/activty/freeaway/appfreeaway_06.jpg">
    <img src="/static/images/activty/freeaway/appfreeaway_07.jpg">
    <img src="/static/images/activty/freeaway/appfreeaway_08.jpg">
    </div>
</template>
<script>
export default {
  name: 'freeaway',
  components: {},
  data() {
    return {
    }
  },
  watch: {
  },
  mounted() {},
  created() {
    this.$store.commit('SET_HEADER_TITLE', this.$t('title.newPlaceToBuy'));
  },
  methods: {
    
  },
}

</script>
<style scoped>
.newplace{
  background: #000;
}
.newplace img{
  width: 100%;
  display: block;
  overflow: hidden;
}
.freeaway{
  position: relative;
  height: 581px;
  overflow: hidden;
}
.freeaway ul{
  position: relative;
  z-index: 2;
  color: #fff;
  display: flex;
  width: 1052px;
  margin: 23px auto 0;
}
.freeaway ul li{
  width: calc(1052px / 5);
}
.freeaway .img{
  height: 266px;
}
.freeaway .img img{
  height: 100%;
  width: auto;
  margin: 0 auto;
  object-fit: contain;
  transform: scale(.7);
  transition:.2s ;
}
.freeaway .img:hover img{
  transform: scale(.8)
}
.freeaway .positive{
  font-size: 24px;
  color: #f4e275;
  text-align: center;
  margin-top: -10px;
}
.freeaway .positive span{
  font-size: 12px;
  color: #fff;
  display: block;
}
.freeaway .freeaway_04{
  position: absolute;
  top: 0;
  left: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/activity/appfreeaway.vue